import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function ReturnsPage() {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-489">
      <Header data-id="element-490" />

      <main className="flex-grow pt-32 pb-20" data-id="element-491">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-492">
          {/* Title */}
          <h1 className="text-3xl md:text-4xl font-bold text-red-600 text-center uppercase mb-12" data-id="element-493">
            Returns & Refunds Policy
          </h1>

          <div className="space-y-10 text-gray-800 leading-relaxed" data-id="element-494">
            {/* Final Sale Items */}
            <section data-id="element-495">
              <h2 className="text-xl font-bold text-gray-900 uppercase mb-4" data-id="element-496">
                Final Sale Items
              </h2>
              <ul className="space-y-2" data-id="element-497">
                <li data-id="element-498">
                  • <strong data-id="element-499">Electronics</strong>,{' '}
                  <strong data-id="element-500">electronic headgear</strong>, and{' '}
                  <strong data-id="element-501">electronic chest protectors</strong> are{' '}
                  <strong data-id="element-502">non-returnable</strong>.
                </li>
                <li data-id="element-503">
                  • <strong data-id="element-504">Engraved</strong> or{' '}
                  <strong data-id="element-505">customized items</strong> are{' '}
                  <strong data-id="element-506">non-returnable</strong>.
                </li>
                <li data-id="element-507">
                  • <strong data-id="element-508">Used items</strong> are{' '}
                  <strong data-id="element-509">not eligible</strong> for return or exchange.
                </li>
              </ul>
            </section>

            {/* Dead on Arrival */}
            <section data-id="element-510">
              <h2 className="text-xl font-bold text-gray-900 uppercase mb-4" data-id="element-511">
                Dead on Arrival (DOA)
              </h2>
              <ul className="space-y-2" data-id="element-512">
                <li data-id="element-513">
                  • <strong data-id="element-514">Electronics</strong> that arrive defective are
                  eligible for <strong data-id="element-515">exchange only</strong>. Refunds are not
                  available for DOA items.
                </li>
              </ul>
            </section>

            {/* Returns */}
            <section data-id="element-516">
              <h2 className="text-xl font-bold text-gray-900 uppercase mb-4" data-id="element-517">
                Returns
              </h2>
              <ul className="space-y-2" data-id="element-518">
                <li data-id="element-519">
                  • <strong data-id="element-520">Reply to your confirmation order email</strong> to
                  request a return.
                </li>
                <li data-id="element-521">
                  • Returns are only on unused, without engravings, with the
                  packaging, <strong data-id="element-522">within 7 days</strong>.
                </li>
                <li data-id="element-523">
                  • <strong data-id="element-524">Shipping charges are non-refundable</strong> once an
                  item has shipped.
                </li>
                <li data-id="element-525">
                  • Approved refunds issued to a <strong data-id="element-526">credit card</strong>{' '}
                  are subject to a <strong data-id="element-527">5% return/transaction fee</strong>.
                </li>
              </ul>
            </section>

            {/* Warranties */}
            <section data-id="element-528">
              <h2 className="text-xl font-bold text-gray-900 uppercase mb-4" data-id="element-529">
                Warranties
              </h2>
              <ul className="space-y-2" data-id="element-530">
                <li data-id="element-531">
                  • Manufacturer warranties remain valid on engraved items.
                </li>
                <li data-id="element-532">
                  • Warranties for <strong data-id="element-533">Daedo socks and gloves</strong> cover{' '}
                  <strong data-id="element-534">normal wear and tear only</strong>.
                </li>
                <li data-id="element-535">
                  • For warranty claims or questions, contact info@tkdscore.com.
                </li>
              </ul>
            </section>
          </div>
        </div>
      </main>

      <Footer data-id="element-536" />
    </div>;
}